export function sortByLabel(a, b) {
    const lblA = a.label.toLowerCase();
    const lblB = b.label.toLowerCase();
    if (lblA < lblB) return -1;
    if (lblA > lblB) return 1;
    return 0;
}

export function sortByName(a, b) {
    const nameA = a.name.toLowerCase();
    const nameB = b.name.toLowerCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
}

export function sortByOrder(a, b) {
    if (a.order < b.order) return -1;
    if (a.order > b.order) return 1;
    return 0;
}

export function sortByProp(arr, prop, t) {
    if (!arr || !prop) return [];
    return arr.sort((a, b) => {
        const aProp = t ? t(a[prop]) : a[prop];
        const bProp = t ? t(b[prop]) : b[prop];
        if (aProp < bProp) {
            return -1;
        }
        if (aProp > bProp) {
            return 1;
        }
        return 0;
    });
}

export function remove(array, element, attr) {
    let index = -1;
    if (attr) {
        index = array.findIndex((item) => item[attr] === element);
    } else {
        index = array.indexOf(element);
    }
    if (index > -1) {
        array.splice(index, 1);
    }
}
